import { render, staticRenderFns } from "./BreadcrumbSeparator.vue?vue&type=template&id=6232753b&"
import script from "./BreadcrumbSeparator.vue?vue&type=script&lang=js&"
export * from "./BreadcrumbSeparator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports